/**
 * Countdown Auto-Calculate Patch v2.1
 * TechTrends Theme v1.144.5
 * This script patches the countdown-component to support auto-calculating
 * the cutoff time based on a daily schedule (default: 12PM/noon)
 *
 * Features:
 * - Auto-calculates next cutoff time when data-timervalue is "auto" or empty
 * - Automatically fixes past dates by calculating the next cutoff
 * - Supports custom cutoff hours via data-cutoff-hour attribute
 *
 * Usage: Set data-timervalue="auto" on the countdown timer element
 */
(function() {
  'use strict';

  // Wait for jQuery and countdown plugin to be available
  function waitForJQuery(callback) {
    if (typeof $ !== 'undefined' && $.fn && $.fn.countdown) {
      callback();
    } else {
      setTimeout(function() {
        waitForJQuery(callback);
      }, 50);
    }
  }

  // Helper: Check if date is in the past
  function isDatePast(dateStr) {
    if (!dateStr || dateStr === 'auto' || dateStr.trim() === '') {
      return true;
    }
    try {
      // Handle both YYYY/MM/DD and YYYY-MM-DD formats
      const normalizedDate = dateStr.replace(/\//g, '-');
      const d = new Date(normalizedDate);
      if (isNaN(d.getTime())) {
        console.warn('[Countdown Auto] Invalid date format:', dateStr);
        return true;
      }
      return d <= new Date();
    } catch (e) {
      console.warn('[Countdown Auto] Error parsing date:', dateStr, e);
      return true;
    }
  }

  // Helper: Get next cutoff time
  function getNextCutoffTime(cutoffHour) {
    cutoffHour = parseInt(cutoffHour) || 12;

    const now = new Date();
    const cutoffToday = new Date();
    cutoffToday.setHours(cutoffHour, 0, 0, 0);

    let targetCutoff;
    if (now >= cutoffToday) {
      // If we've passed today's cutoff, use tomorrow
      targetCutoff = new Date(cutoffToday);
      targetCutoff.setDate(targetCutoff.getDate() + 1);
    } else {
      targetCutoff = cutoffToday;
    }

    const year = targetCutoff.getFullYear();
    const month = (targetCutoff.getMonth() + 1).toString().padStart(2, '0');
    const day = targetCutoff.getDate().toString().padStart(2, '0');
    const hours = targetCutoff.getHours().toString().padStart(2, '0');

    return year + '/' + month + '/' + day + ' ' + hours + ':00:00';
  }

  function applyPatch() {
    // Store original countdown initialization
    const originalCountdown = $.fn.countdown;

    if (!originalCountdown) {
      console.error('[Countdown Auto] Original countdown plugin not found!');
      return;
    }

    // Patch: Override countdown to handle "auto" value and past dates
    $.fn.countdown = function(targetDate, callback) {
      const element = this;
      const cutoffHour = parseInt(element.data('cutoff-hour')) || 12;

      // Check if we need to auto-calculate
      if (targetDate === 'auto' || targetDate === '' || !targetDate || isDatePast(targetDate)) {
        const newTargetDate = getNextCutoffTime(cutoffHour);
        console.log('[Countdown Auto] Auto-calculated cutoff time:', newTargetDate, '(was:', targetDate, ')');
        targetDate = newTargetDate;
      }

      // Call original countdown with the corrected date
      return originalCountdown.call(this, targetDate, callback);
    };

    console.log('[Countdown Auto] Patch v2.0 loaded - cutoff time auto-calculation enabled');

    // Re-initialize any existing countdown elements that may have failed
    document.querySelectorAll('countdown-component').forEach(function(el) {
      const timer = el.querySelector('[data-timer]');
      if (timer) {
        const timerValue = timer.dataset.timervalue;
        const timerHtml = timer.innerHTML;

        // Check if the timer shows NaN (failed initialization)
        if (timerHtml.includes('NaN') || timerHtml.trim() === '') {
          const cutoffHour = parseInt(timer.dataset.cutoffHour) || 12;
          const languages = JSON.parse(timer.dataset.timerLanguages || '{"days":"d","hours":"h","minutes":"m","seconds":"s"}');
          const point = timer.dataset.timerPoint || '';

          // Get corrected target date
          const correctedDate = isDatePast(timerValue) ? getNextCutoffTime(cutoffHour) : timerValue;

          // Build language spans
          let daysLang = '', hoursLang = '', minutesLang = '', secondsLang = '', pointSpan = '';
          if (languages.days !== '') daysLang = '<span class="language">' + languages.days + '</span>';
          if (languages.hours !== '') hoursLang = '<span class="language">' + languages.hours + '</span>';
          if (languages.minutes !== '') minutesLang = '<span class="language">' + languages.minutes + '</span>';
          if (languages.seconds !== '') secondsLang = '<span class="language">' + languages.seconds + '</span>';
          if (point !== '') pointSpan = '<span class="point">' + point + '</span>';

          // Re-initialize countdown with corrected date
          $(timer).countdown(correctedDate, function(event) {
            $(event.currentTarget).html(event.strftime(
              "<div class='timer'>" +
              "<span class='number'>%D</span>" + daysLang + pointSpan +
              "<span class='number'>%H</span>" + hoursLang + pointSpan +
              "<span class='number'>%M</span>" + minutesLang + pointSpan +
              "<span class='number'>%S</span>" + secondsLang +
              "</div>"
            ));
          });

          console.log('[Countdown Auto] Re-initialized countdown with date:', correctedDate);
        }
      }
    });
  }

  // Wait for dependencies and apply patch
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      waitForJQuery(applyPatch);
    });
  } else {
    waitForJQuery(applyPatch);
  }
})();
